<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :color="'#353535'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    mobile-break-point="960"
    app
    mini-variant-width="80"
    width="300"
    v-bind="$attrs"
    @mouseleave.native="drawerHover = false"
    @mouseover.native="drawerHover = true"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">
            Mudar Empresa
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <general-select-empresa-sistema ref="refSelectEmp" />
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              text
              @click="dialog = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              :loading="loading"
              @click="changeEmpresa()"
            >
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>


    <div
      style="position: relative;"
    >
      <v-list-item two-line>
        <v-list-item-content
          align="center"
          justify="center"
        >
          <router-link :to="toPathLogo">
            <v-img
              v-if="shouldExpand"
              width="150"
              height="50"
              src="@/assets/hexa_logo_branco.png"
            />
            <v-img
              v-else
              width="35"
              height="40"
              src="@/assets/logo_hexa_hexagono_branco.png"
            />
          </router-link>
        </v-list-item-content>
      </v-list-item>

      <v-divider
        class="mb-1"
        style="margin-top:10px"
      />

      <v-list
        id="drawer-section-profile"
        dense
        nav
      >
        <base-item-group
          v-if="profile"
          :item="profile"
          class="drawerItemList"
          :recolher-sub-menus="this.isMobile || drawerHover"
        />
      </v-list>

      <v-divider class="mb-2" />

      <div @click="openDialog">
        <v-list
          id="drawer-section-mudar-empresa"
          dense
          nav
        >
          <base-item
            :item="selectEmpresaSistema"
          />
        </v-list>
      </div>

      <v-divider class="mb-2" />

      <v-list
        expand
        nav
      >
        <!-- Style cascading bug  -->
        <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
        <div />

        <template v-for="(item, i) in computedItems">
          <base-item-group
            v-if="item.children"
            :key="`group-${i}`"
            :item="item"
          >
            <!--  -->
          </base-item-group>

          <base-item
            v-else
            :key="`item-${i}`"
            :item="item"
            :id-element="'drawer-section-'+item.title.toLowerCase().replace(/ /g, '')"
            :dialog-disabled="item.dialogDisabled"
          />
        </template>

        <!-- Style cascading bug  -->
        <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
        <div />
      </v-list>

      <v-divider class="mb-2" />
      
      <v-list
        expand
        nav
        v-if="!isMobile"
      >
        <v-list-item
          id="drawer-section-tutorial"
          :href="undefined"
          @click="forceInitTourCurrentPage()"
        >
          <v-list-item-icon
            class="v-list-item__icon--text"
          >
            <v-icon v-text="'mdi-help-circle'" />
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-text="'Tutorial'" />
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider
        class="mb-1"
        style="margin-top:10px"
        v-if="!isMobile"
      />

      <!-- <v-list
        expand
        nav
      >
        <v-list
          class="d-flex justify-center"
        > -->
      <!--v-btn
            v-if="!Faqhover"
            color="white"
            fab
            small
            @mouseover.native="Faqhover = true"
          >
            <div class="display-2 font-weight-medium">
              ?
            </div>
          </v-btn>

          <v-btn-toggle
            v-else
            color="grey"
            background-color="white"
            rounded
            small
            @mouseleave.native="Faqhover = false"
          >
            <v-btn
              class="display-1 font-weight-medium"
              color="white"
              rounded
            >
              FAQ
            </v-btn>
            <v-btn
              class="display-1 font-weight-medium"
              color="white"
              rounded
            >
              CHAT
            </v-btn>
          </v-btn-toggle-->

      <!--v-btn
            color="white"
            outlined
            fab
            small
            elevation="1"
            @click="openTawkChat"
          >
            <v-icon>mdi-chat-processing</v-icon>
          </v-btn-->

      <!-- </v-list>
      </v-list> -->
    </div>
    <div 
      v-if="shouldExpand"
      :style="'position:'+getCssLogoPositionLogo+';width:300px; bottom:0'"
    >
      <div
        align="center"
        justify="center"
      >
        <v-img
          width="180"
          height="80"
          src="@/assets/logo_norven_negativo_tagline.png"
        />
      </div>
      
      <div
        align="center"
        justify="center"
        class="mb-3 mt-n5"
      >
        <v-btn
          color="white"
          dark
          icon
          min-width="0"
          href="https://norven.com.br"
          target="_blank"
        >
          <v-icon
            size="25"
            color="white"
          >
            mdi-web
          </v-icon>
        </v-btn>
        <v-btn
          color="white"
          dark
          icon
          min-width="0"
          href="https://www.linkedin.com/company/norvenbr/"
          target="_blank"
        >
          <v-icon
            size="25"
            color="white"
          >
            mdi-linkedin
          </v-icon>
        </v-btn>
        <v-btn
          color="white"
          dark
          icon
          min-width="0"
          href="https://www.youtube.com/channel/UCq_3TspPFJhJogl0ug7rmYQ"
          target="_blank"
        >
          <v-icon
            size="25"
            color="white"
          >
            mdi-youtube
          </v-icon>
        </v-btn>
      </div>
    </div>
    <div
      v-else 
      style="position:fixed; bottom:0px; width:80px"
      align="center"
      justify="center"
    >
      <router-link :to="toPathLogo">
        <v-img
          width="80"
          height="80"
          src="@/assets/norven_simbolo_branco.png"
        />
      </router-link>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Firestore from '@/Firestore.js';


export default {
  name: 'DashboardCoreDrawer',

  components: {
    GeneralSelectEmpresaSistema: () => import('@/components/general/SelectEmpresaSistema')
  },

  props: {
    expandOnHover: {
      type: Boolean,
      default: false
    },
    drawerExpanded: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    dialog: false,
    drawerHover: false,
    nomeEmpresa: '',
    siglaEmpresa: '',
    Faqhover: false,
    profilePic: null,
    profile: null,
    itemTour: {
      icon: 'mdi-help-circle',
      title: 'Tutorial'
    },
    loading: false
  }),

  computed: {
    toPathLogo() {
      if (this.siglaEmpresaVUEX === 'LITE') {
        return '/powerups';
      } else {
        return '/';
      }
    },

    ...mapState(['barColor', 'barImage']),

    selectEmpresaSistema () {
      return {
        sigla: this.siglaEmpresa,
        title: this.nomeEmpresa
      };
    },

    drawer: {
      get () {
        return this.$store.state.drawer;
      },
      set (val) {
        this.$store.commit('SET_DRAWER', val);
      }
    },

    siglaEmpresaVUEX() {
      return this.$store.getters.getSiglaEmpresa;
    },

    isMobile() {
      return this.$vuetify.breakpoint.smAndDown; 
    },

    computedItems () {
      let items = [
        {
          icon: 'mdi-view-dashboard',
          title: 'Dashboard',
          to: '/',
          disabled: this.siglaEmpresaVUEX === 'LITE' ? true : false,
          dialogDisabled: {'released': true, 'msg':  'Esta ferramenta não está habilitada para seu usuário, caso tenha interesse, entre em contato com um especialista <b>NORVEN</b> pelo chat.'}
        }
      ];

      if (!this.isMobile && this.canAccessReports) {
        items.push(
          {
            icon: 'mdi-clipboard-outline',
            title: 'Relatórios',
            to: '/relatorios/historico',
            disabled: this.siglaEmpresaVUEX === 'LITE' ? true : false,
            dialogDisabled: {'released': true, 'msg':  'Esta ferramenta não está habilitada para seu usuário, caso tenha interesse, entre em contato com um especialista <b>NORVEN</b> pelo chat.'}
          }
        );
      }

      if (!this.isMobile) {
        items.push(
          {
            to: '/powerups',
            icon: 'mdi-lightning-bolt',
            title: 'Power Ups'
          },
          {
            to: '/dados',
            icon: 'mdi-database',
            title: 'Dados',
            disabled: this.siglaEmpresaVUEX === 'LITE' ? true : false,
            dialogDisabled: {'released': true, 'msg':  'Esta ferramenta não está habilitada para seu usuário, caso tenha interesse, entre em contato com um especialista <b>NORVEN</b> pelo chat.'}
          }
        );
      }

      if (!this.isMobile && (this.userIsAdmin || this.userIsManager)) {
        items.push({
          icon: 'mdi-account-tie',
          to: '/administracao',
          title: 'Administração'
        });
      }

      return items.map(this.mapItem);
    },

    user() {
      return this.$store.getters.getUser;
    },

    userIsAdmin() {
      return this.$store.getters.userIsAdmin;
    },

    userIsManager() {
      return this.$store.getters.getUserIsManager;
    },

    getCssLogoPositionLogo() {
      let heightDrawer = document.getElementById('core-navigation-drawer');
      heightDrawer = heightDrawer ? heightDrawer.offsetHeight : 645;
      return heightDrawer <= 644 ? 'relative' : 'fixed';
    },

    storeEmpresa() {
      return this.$store.getters.getEmpresa;
    },

    canAccessReports(){
      return this.$store.state.app.modulosPerfisLiberados.tabelas_liberadas.length > 0 ? true : false;
    },

    shouldExpand() {
      return this.drawerExpanded || (this.drawerHover && !this.drawerExpanded) || this.isMobile;
    }
  },

  watch: {
    isMobile(val) {
      this.$emit('update:expandOnHover', !val);
    }
  },

  async mounted () {
    this.$emit('update:expandOnHover', !this.isMobile);

    Firestore.collection('empresas')
      .where('url', '==', this.storeEmpresa)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.nomeEmpresa = doc.data().nome;
          this.siglaEmpresa = doc.data().sigla;
        });
      });

    this.getProfile();
  },

  methods: {
    getProfile () {

      const perfilNome = this.user.nome + ' ' + this.user.sobrenome;
      const obj = {};

      obj.avatar = true;
      obj.img = this.user.profile_picture ? this.user.profile_picture : false;
      obj.group = '/perfil';
      obj.title = perfilNome;
      obj.children = [
        {
          icon: 'mdi-account',
          to: 'edit',
          title: 'Perfil'
        },
        {
          icon: 'mdi-logout',
          to: 'logout',
          title: 'Logout'
        }
      ];

      this.profile =  obj;
    },

    openDialog () {
      this.dialog = true;
    },

    mapItem (item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title)
      };
    },


    async changeEmpresa() {
      this.loading = true;
      await this.$refs.refSelectEmp.changeSelectedEmpresa();
      this.loading = false;
      location.reload();
    },

    forceInitTourCurrentPage() {
      let arrTourInfo = this.$store.getters.getTourInfo;
      let nomePagina = this.$router.history.current.name;
      let existeTourCurrentPage = false;

      arrTourInfo.forEach(tourInfo => {
        if (tourInfo.nome_pagina == nomePagina) {
          tourInfo.tour_completado = '0';
          existeTourCurrentPage = true;
        }
      });

      if (!existeTourCurrentPage) {
        this.$toast.info('Não existe nenhum tutorial cadastrado para essa página, caso precise de ajuda entre em contato com um especialista <b>HEXA</b>.', '', {position:'topRight'});
      } else {
        this.$store.dispatch('setTour', arrTourInfo);
        location.reload();
      }
    }
  }
};
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    &.v-navigation-drawer--mini-variant
      .v-list-item
        justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>